/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export function getLocalValue<T>(key: string, defaultValue: T): T {
  const item = localStorage.getItem(key);
  return item ? JSON.parse(item) : defaultValue;
}

export function setLocalValue<T>(key: string, value: T): void {
  localStorage.setItem(key, JSON.stringify(value));
}
